import React from 'react'
import {Card, Row, Col, Container, ListGroup, ListGroupItem, Table} from 'react-bootstrap';
import front from './images/front.png';
import back from './images/back.png';
import other from './images/other.png';
import learn from './images/learn.png';

export const Skills = () => {
    return (
        <div>
            <h2 style={{textAlign: 'center', color: 'white'}}><strong>Skills:</strong></h2>
            
            <Container fluid>
                <Row>
                <Col md={3} style={{textAlign: 'center'}}>
                    <img src={front} height = {100} width = {100}/>
                    <h3><strong>Frontend</strong></h3>
                    <Table striped bordered hover style={styles.cardStyle}>
                        <tr><td>HTML | CSS</td></tr>
                        <tr><td>Bootstrap</td></tr>
                        <tr><td>Javascript</td></tr>
                        <tr><td>React | Redux</td></tr>
                    </Table>
                </Col>

                <Col md={3} style={{textAlign: 'center'}}>
                    <img src={back} height = {100} width = {100}/>
                    <h3><strong>Backend</strong></h3>
                    <Table striped bordered hover style={styles.cardStyle}>
                        <tr><td>Node JS | Express JS</td></tr>
                        <tr><td>Python | Flask</td></tr>
                        <tr><td>Postman</td></tr>
                        <tr><td>MongoDB</td></tr>
                    </Table>
                </Col>

                <Col md={3} style={{textAlign: 'center'}}>
                    <img src={other} height = {100} width = {100}/>
                    <h3><strong>Others</strong></h3>
                    <Table striped bordered hover style={styles.cardStyle}>
                        <tr><td>Git | GitHub</td></tr>
                        <tr><td>Machine Learning</td></tr>
                        <tr><td>Web Scraping</td></tr>
                        <tr><td>PyQt5</td></tr>
                    </Table>
                </Col>

                <Col md={3} style={{textAlign: 'center'}}>
                    <img src={learn} height = {100} width = {100}/>
                    <h3><strong>Learning</strong></h3>
                    <Table striped bordered hover style={styles.cardStyle}>
                        <tr><td>Next JS</td></tr>
                        <tr><td>TypeScript</td></tr>
                        <tr><td>Jest | Enzyme</td></tr>
                        <tr><td>React Native</td></tr>
                    </Table>
                </Col>
                </Row>
            </Container>
        </div>
    )
}

const styles = {
    cardStyle: {
        border: 'solid 3px white',
        fontSize: '2vh',
        color: 'white',
    },
}